module.exports = __webpack_public_path__ + "img/traffic_car.85c20099.png";